var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('a-icon',{attrs:{"component":_vm.phonepeSvg,"spin":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }